/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RaceClass } from '../../models/race-class';

export interface UpdateRaceClasses$Params {
  raceGuid: string;
  raceClassGuid: string;
      body: RaceClass
}

export function updateRaceClasses(http: HttpClient, rootUrl: string, params: UpdateRaceClasses$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RaceClass>>> {
  const rb = new RequestBuilder(rootUrl, updateRaceClasses.PATH, 'put');
  if (params) {
    rb.path('raceGuid', params.raceGuid, {"style":"simple"});
    rb.path('raceClassGuid', params.raceClassGuid, {"style":"simple"});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RaceClass>>;
    })
  );
}

updateRaceClasses.PATH = '/races/{raceGuid}/classes/{raceClassGuid}';
